module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['op--modal-container', {
      hide: !_vm.show
    }],
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "shared-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "sb-title"
  }, [_vm._v(_vm._s(_vm.$t('serviceSelect.tryService2', {
    service: _vm.targetService
  })))]), _vm._v(" "), _c('div', {
    staticClass: "sb-body"
  }, [_c('p', [(_vm.allowTime.start !== _vm.allowTime.end) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$t('serviceSelect.serviceAirportAvailable1', {
    service: _vm.sharedLabel,
    start: _vm.allowTime.start,
    end: _vm.allowTime.end,
  })) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(_vm.$t('serviceSelect.serviceAirportAvailable2', {
    service: _vm.sharedLabel
  })) + "\n            ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.service),
      expression: "!!service"
    }]
  }, [_vm._v(_vm._s(_vm.$t('serviceSelect.wouldYouLike', {
    service: _vm.targetService
  })))]), _vm._v(" "), _c('span', {
    staticClass: "loaderx"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serviceLoading),
      expression: "serviceLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.service),
      expression: "!!service"
    }],
    staticClass: "op-btn btn-success btn-block btn-md margin-t-l",
    on: {
      "click": _vm.selectNextService
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('serviceSelect.yesChoose', {
    service: _vm.targetService
  })) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "op-btn btn-block btn-md margin-t-s",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-730f5152", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-730f5152","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceSelection/SharedAllotedTimeModal.vue
// module id = 2112
// module chunks = 0